import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {UtilsService} from '../services/utils.service';
import {environment} from '../../../environments/environment';
import {UserLogged} from '../../models/userLogged';
import {firstValueFrom} from 'rxjs';
import {UserUtilsService} from '../../services/user-utils.service';

@Injectable()
export class AuthGuard {

  constructor(
    public authenticationService: AuthenticationService,
    public utilsService: UtilsService,
    private router: Router,
    private userUtilsService: UserUtilsService,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    let currentUser = null;
    if (this.utilsService.getUserData('currentUser' + environment.subCookiesDomain)) {
      currentUser = this.utilsService.getUserData('currentUser' + environment.subCookiesDomain);
    } else {
      currentUser = this.authenticationService.userAuthenticated;
    }
    if (!currentUser) {
      this.authenticationService.redirectUrl = state.url;
      // not logged in so redirect to login page and save the url
      return false;
    } else {
      if (this.authenticationService.isTokenExpired()) {
        this.utilsService.lockUi();
        this.authenticationService.redirectUrl = state.url;
        return firstValueFrom(this.authenticationService.refreshTokenUsingWs$()).then(result => {
          this.utilsService.unlockUi();
          if (result === null) {
            this.authenticationService.logoutUser();
          } else {
            return this.handlGuard(route, currentUser);
          }
        }).catch(() => {
          this.utilsService.unlockUi();
          this.authenticationService.logoutUser();
        });
      } else {
        return this.handlGuard(route, currentUser);
      }
    }
  }

  private handlGuard(route: ActivatedRouteSnapshot, currentUser: UserLogged) {
    let access = false;
    if (!route.data && (!route.data.expectedRoles || !route.data.expectedPermissions || !route.data.unexpectedPermissions)) {
      return true;
    }
    if (currentUser && route.data) {
      if (route.data.unexpectedPermissions) {
        if (this.authenticationService.userHasOneOfThosePermissions(route.data.unexpectedPermissions)) {
          return false;
        }
        access = true;
      }
      const currentCompanyUniqId = route.params.currentCompanyUniqId;
      const userCompany = this.authenticationService.getUserCurrent()?.company;
      if (currentCompanyUniqId && currentCompanyUniqId !== userCompany?.uniqid) {
        return this.homeUrlTree();
      }
      if (route.data.expectedRoles) {
        const expectedRoleArray = route.data && route.data.expectedRoles;
        if (!this.authenticationService.userHasOneOfThoseRoles(expectedRoleArray)) {
          return this.homeUrlTree();
        }
        access = true;
      }
      if (route.data.expectedPermissions) {
        const expectedPermissionsArray = route.data && route.data.expectedPermissions;
        if (this.authenticationService.userHasAllOfThosePermissions(expectedPermissionsArray)) {
          return true;
        }
        return this.homeUrlTree();
      }
    }
    // not logged in so redirect to login page with the return url
    return access;
  }

  private homeUrlTree(): UrlTree | boolean {
    const company = this.authenticationService.getUserCurrent()?.company;
    if (!company?.uniqid) {
      return false;
    }
    const home = this.userUtilsService.isClientCompany(company) ? 'client' : 'mckay';
    return this.router.createUrlTree(['/' + home, company.uniqid]);
  }
}
